import { Resource, ResourceType } from 'json-api-hooks';
import React, { FC } from 'react';

import { ResourceFormProps } from '../../components/./Form/ResourceForm';
import MenuItem from '../../components/MenuItem';
import useModalDispatch from '../../hooks/useModalDispatch';
import UpdateResourceModal, { UpdateResourceModalProps } from '../../modals/UpdateResourceModal';

const UpdateMenuItem = <T extends ResourceType>({
  form,
  formLabel,
  resource,
}: {
  form: FC<Partial<ResourceFormProps<T>>>;
  formLabel: string;
  resource: Resource<T>;
}) => {
  const openModal = useModalDispatch<UpdateResourceModalProps<T>>(UpdateResourceModal);

  return (
    <MenuItem
      href="#"
      icon="pencil"
      onClick={(e) => {
        e.preventDefault();
        openModal({ form, label: formLabel, id: resource.id, type: resource.type });
      }}
    >
      Bewerken
    </MenuItem>
  );
};

export default UpdateMenuItem;
